// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCY0s6lVlOQ7sZTooLhfmsTkt5sVySLVFA",
  authDomain: "gradly-app.firebaseapp.com",
  projectId: "gradly-app",
  storageBucket: "gradly-app.firebasestorage.app",
  messagingSenderId: "605678575199",
  appId: "1:605678575199:web:be0e5262d0462dd50305ea",
  measurementId: "G-5F25F1HE3R"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export { app, analytics };